import { ApiResponseError } from '../ApiResponseError';
import { UserVerificationStatus } from './model/UserVerificationStatus';

export const getUserVerified: () => Promise<UserVerificationStatus> = async () => {
  const response = await fetch(`${process.env.TVS_SERVICE_BASE_URL}/api/user/verifications`, {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  });
  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
  return (await response.json()) as UserVerificationStatus;
};
